import { Shield } from "lucide-react";

const SessionRestoring = () => {
  return (
    <div className="tw">
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-white flex items-center justify-center p-4">
        <div className="text-center animate-fade-in">
          <div className="mb-8">
            <div className="relative inline-flex items-center justify-center">
              <div className="w-[64px] h-[64px] bg-emerald-50 rounded-2xl flex items-center justify-center mb-2">
                <Shield className="w-[32px] h-[32px] text-emerald-600" />
              </div>
              <div className="absolute inset-0 w-16 h-16 bg-emerald-100 roundend-2xl animate-ping opacity-20"></div>
            </div>
          </div>
          <div className="space-y-4 max-w-sm mx-auto">
            <h2 className="text-xl font-semibold text-slate-800">
              Just a moment...
            </h2>
            <p className="text-slate-500 text-base leading-relaxed">
              We're logging you back into your account securely
            </p>
          </div>
          <div className="mt-8">
            <div className="w-full h-2 bg-slate-100 rounded-full mx-auto overflow-hidden">
              <div className="h-full bg-gradient-to-r from-emerald-500 to-blue-500 rounded-full animate-progress"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionRestoring;
